import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 价格预警查询类型
 */
class QueryType extends UltMeta {
    ORIGIN_BOARDING_PRICE = new Meta(1, "产地上船价");
    WUHU_PORT_PRICE = new Meta(3, "芜湖靠港价");
    JIANGYIN_PORT_PRICE = new Meta(2, "江阴靠港价");
}

export const PRODUCT_TYPE_PRICE_WARNING_QUERY_TYPE = new QueryType();

/**
 * 价格预警状态
 */
class WarningState extends UltMeta {
    ENABLED = new Meta(1, "已生效");
    DISABLED = new Meta(0, "已失效");
}

export const PRODUCT_TYPE_PRICE_WARNING_STATE = new WarningState();

/**
 * 价格预警置顶状态
 */
class TopState extends UltMeta {
    TOPPED = new Meta(1, "已置顶");
    UNTOPPED = new Meta(0, "未置顶");
}

export const PRODUCT_TYPE_PRICE_WARNING_TOP = new TopState();
